import React from 'react';
import { Tooltip } from 'antd';
import { predicatesToText } from '../../helpers';
import {
  NOT_EDITABLE, NOT_BULK_EDITABLE, NO_ITEMS_SELECTED, UPLOAD_NOT_AVAILABLE, IS_OPTIMISE,
  DATA_EXISTS, DATA_IS_LINKED, NOT_ADDABLE, NO_EDITS, VOLUME_IS_LINKED, NOT_DELETABLE, COPY_DISABLED,
} from '../../constants/text.constants';

const textMap = {
  isCheckingOptimising: IS_OPTIMISE,
  isOptimising: IS_OPTIMISE,
  isNotEditable: NOT_EDITABLE,
  isNotBulkEditable: NOT_BULK_EDITABLE,
  noItemsSelected: NO_ITEMS_SELECTED,
  uploadNotAvailable: UPLOAD_NOT_AVAILABLE,
  dataExists: DATA_EXISTS,
  dataIsLinked: DATA_IS_LINKED,
  isNotAddable: NOT_ADDABLE,
  noEdits: NO_EDITS,
  volumeIsLinked: VOLUME_IS_LINKED,
  isNotDeletable: NOT_DELETABLE,
  copyDisabled: COPY_DISABLED,
};

const DisabledTooltip = ({ predicates, children, ...rest }) => (
  <Tooltip
    {...rest}
    title={
      predicatesToText(predicates, textMap)
    }
  >
    {children}
  </Tooltip>
);

export default DisabledTooltip;
